import moment, { MomentInput } from 'moment';

export const dateFormats = {
  common: 'DD/MM/YYYY',
  compact: 'DD/MM/YY'
};

export function formatDateCommon(value: MomentInput) {
  return moment(value).format(dateFormats.common);
}